// Import model
import { UpdatePromptRequest } from '../models/UpdatePromptRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { UpdateMessageRequest } from '../models/UpdateMessageRequest';

// Import dependency serializers (for complex types)
import { UpdateMessageRequestSerializer } from './UpdateMessageRequestSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for UpdatePromptRequest - handles JSON serialization and deserialization with type validation
 */
export class UpdatePromptRequestSerializer {
  /**
   * Deserializes a JSON string into a UpdatePromptRequest instance
   */
  static deserialize(json: string): UpdatePromptRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a UpdatePromptRequest instance
   */
  static fromObject(obj: any): UpdatePromptRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to UpdatePromptRequest');
    }


    const instance: UpdatePromptRequest = {
      assistantId: obj['AssistantId'] as string | undefined,
      chatStatuses: obj['ChatStatuses'] ? (obj['ChatStatuses'] as any[]).map((item: any) =>
        item as string
      ) : [] as any,
      messages: obj['Messages'] ? (obj['Messages'] as any[]).map((item: any) =>
        UpdateMessageRequestSerializer.fromObject(item)
      ) : [] as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of UpdatePromptRequest instances
   */
  static deserializeArray(json: string): UpdatePromptRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a UpdatePromptRequest instance to a JSON string
   */
  static serialize(instance: UpdatePromptRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a UpdatePromptRequest instance to a plain object
   */
  static toObject(instance: UpdatePromptRequest): any {
    return {
      'AssistantId': instance.assistantId,
      'ChatStatuses': instance.chatStatuses?.map((item: any) =>
        item
      ),
      'Messages': instance.messages?.map((item: any) =>
        UpdateMessageRequestSerializer.toObject(item)
      ),
    };
  }

  /**
   * Serializes an array of UpdatePromptRequest instances to a JSON string
   */
  static serializeArray(instances: UpdatePromptRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
